/**
 * Isolated PostHog native shell — lazy-required from AnalyticsProvider so
 * posthog-react-native is not loaded at app bundle init on iOS.
 */

import type { ReactNode } from 'react'
import { PostHogProvider, usePostHog } from 'posthog-react-native'
import { PostHogClientContext, type PostHogClientLike } from './PostHogClientContext'

interface PostHogAnalyticsShellProps {
  apiKey: string
  host: string
  children: ReactNode
}

function PostHogBridge({ children }: { children: ReactNode }) {
  const client = usePostHog()
  return (
    <PostHogClientContext.Provider value={(client ?? null) as PostHogClientLike | null}>
      {children}
    </PostHogClientContext.Provider>
  )
}

export function PostHogAnalyticsShell({ apiKey, host, children }: PostHogAnalyticsShellProps) {
  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        host,
        preloadFeatureFlags: false,
      }}
    >
      <PostHogBridge>{children}</PostHogBridge>
    </PostHogProvider>
  )
}
